import "./RedirectCheck.scss";
import Error from "../../Pages/Error/Error.js";

const RedirectCheck = ({ redirectTo, children }) => {
  /* UNCOMMENT THIS SECTION IF WE NEED TO BRING BACK REDIRECT TO ERROR PAGE */
  
  // const { getLanguage } = useContent();
  // const navigate = useNavigate();
  // const redirectPath = redirectTo
  //   ? `/${getLanguage()}/${redirectTo.isError ? "error/" : null}${
  //       redirectTo.path
  //     }`
  //   : false;
  // !location.pathname.includes("error") &&
  //   navigate(redirectPath);

  return redirectTo && redirectTo.isError ? (
    <Error customType={"keynotexists"} />
  ) : (
    children
  );
};

export default RedirectCheck;
